/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import {
  CHECK_LOG_NUM_REQ,
  DELETE_CHECKLOG_COMPLETED,
  ERROR_DELETE_CHECKLOG,
  REBATE_PROGRAM_REQUIRED_REQ,
} from '../../../../../../SharedModules/Errors/constantMessageData';
import SVGComponent from '../../../../../../SharedModules/SVGComponents/SVGComponents';
import { RadioGroupComponent } from '../../../../../Display/Claim/component/SelectClaim/SelectClaimSearchComponent';
import { NDCDetailsTextFieldComponent } from '../../../../../Display/NDC/component/NDCDetails/NDCDetailsHeaderDetailsComponent';
import {
  deleteCheckLogDetails,
  getCheckLogDetails,
  setDeleteCheckLogFilterValue,
} from '../store/action';
import { PLAN_TYPE_DATA } from '../utils/constant';
import DeleteCheckLogPopup from './DeleteCheckLogPopup';

const DeleteCheckLogHeader = ({
  searchFilter,
  rebateData,
  setErrorMessages,
  setSuccessMessages,
  setDiscrepancies,
}) => {
  const dispatch = useDispatch();
  const [modal, setModal] = useState({ open: false, data: null });

  const handleClose = () => {
    setModal({ open: false, data: null });
  };

  return (
    <>
      <div className='row'>
        <div className='col-6'>
          <fieldset className='custom-fieldset'>
            <legend className='same-font-family'>Plan Type</legend>
            <div className='p-0 mt-2 row'>
              <div className='mui-custom-form col-12 m-0'>
                <RadioGroupComponent
                  data={PLAN_TYPE_DATA}
                  value={searchFilter && searchFilter.planType}
                  onChange={(_, value) => {
                    dispatch(setDeleteCheckLogFilterValue('planType', value));
                    dispatch(setDeleteCheckLogFilterValue('rpc', null));
                    dispatch(
                      setDeleteCheckLogFilterValue('checkPayeeCd', null)
                    );
                  }}
                />
              </div>
            </div>
          </fieldset>
        </div>
        <div className='col-4'>
          <NDCDetailsTextFieldComponent
            label='Rebate Program'
            value={searchFilter && searchFilter.rpc}
            required
            className='ml-0 with-select'
            select
            selectReset
            selectData={rebateData}
            disabled={false}
            onChange={(e) => {
             if (e.target.value === "") {
                dispatch(setDeleteCheckLogFilterValue('rpc', null));
                dispatch(setDeleteCheckLogFilterValue('checkPayeeCd', null));
              } else {
                const filterArr = rebateData.filter(
                  (item) => item.value === e.target.value
                );

                if (filterArr.length > 0) {
                  dispatch(
                    setDeleteCheckLogFilterValue('rpc', filterArr[0].value)
                  );
                  dispatch(
                    setDeleteCheckLogFilterValue(
                      'checkPayeeCd',
                      filterArr[0].checkPayeeCd
                    )
                  );
                }
              }
            }}
          />
        </div>
        <div className='col-2'>
          <NDCDetailsTextFieldComponent
            label='Check Log Number'
            value={(searchFilter && searchFilter.checkLogNum) || ''}
            required
            className='ml-0 mb-0'
            disabled={false}
            onChange={(e) => {
              dispatch(
                setDeleteCheckLogFilterValue('checkLogNum', e.target.value)
              );
            }}
          />
        </div>

        <div className='col-12 my-3 d-flex align-items-center justify-content-end'>
          <Button
            className='btn-success same-font-family d-flex align-items-center'
            onClick={() => {
              const localErrorMessage = [];
              setDiscrepancies([]);
              if (!searchFilter || !searchFilter.rpc) {
                localErrorMessage.push(REBATE_PROGRAM_REQUIRED_REQ);
              }

              if (!searchFilter || !searchFilter.checkLogNum) {
                localErrorMessage.push(CHECK_LOG_NUM_REQ);
              }

              if (localErrorMessage.length > 0) {
                setErrorMessages(localErrorMessage);
                setSuccessMessages([]);
              } else {
                setErrorMessages([]);
                setSuccessMessages([]);
                dispatch(
                  getCheckLogDetails(
                    {
                      checkLogNum: searchFilter.checkLogNum,
                      checkPayeeCd: searchFilter.checkPayeeCd,
                      rebateProgramCd: searchFilter.rpc
                    },
                    (data) => {
                      if (
                        data &&
                        data.discrepencyList &&
                        data.discrepencyList.length > 0
                      ) {
                        setDiscrepancies(data.discrepencyList?.map(discrepency => String(discrepency)?.replace(/check#|Check#/gi, `${searchFilter.checkLogNum}`)));
                      } else if (data && data.checkLogVO) {
                        setModal({ open: true, data: data.checkLogVO });
                      }
                    },
                    (message) => {
                      setErrorMessages(message ? [message] : []);
                    }
                  )
                );
              }
            }}
          >
            <SVGComponent iconName='Create-new-icon' />{' '}
            <span style={{ paddingLeft: '5px' }}>Delete Check Log</span>
          </Button>
        </div>
      </div>
      <DeleteCheckLogPopup
        open={modal.open}
        handleClose={handleClose}
        data={modal.data}
        onConfirmClick={() => {
          setErrorMessages([]);
          setSuccessMessages([]);
          dispatch(
            deleteCheckLogDetails(
              {
                checkLogNum: modal.data && modal.data.checkLogNum,
                checkPayeeCd: modal.data && modal.data.checkPayeeCd,
                rebateProgramCd: searchFilter.rpc
              },
              () => {
                setSuccessMessages([DELETE_CHECKLOG_COMPLETED]);
                dispatch(setDeleteCheckLogFilterValue('checkLogNum', null));
                handleClose();
              },
              (err) => {
                setErrorMessages([err || ERROR_DELETE_CHECKLOG]);
                handleClose();
              }
            )
          );
        }}
      />
    </>
  );
};

export default DeleteCheckLogHeader;
